<template>
  <standard-layout>
    <template v-slot:fixed-top>
      <div class="bg-dark text-center">Test</div>
    </template>
    <template v-slot:heading>
      <sakali-header title="Test"/>
    </template>
    <template v-slot:main>
      <div class="card-sakali">Hauptinhalt</div>
    </template>
    <template v-slot:right1>
      <div class="card-sakali">Rechts1</div>
    </template>
    <template v-slot:right2>
      <div class="card-sakali">Rechts2</div>
    </template>
  </standard-layout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout";

export default {
  components: {
    standardLayout: StandardLayout
  }
}
</script>